export const PREFIX_NAME = 'HITRACT_';

export const PREFIX_CONST_REQUEST = (methodName, constName) => ({
  [`${methodName}_REQUEST`]: `${PREFIX_NAME}_${constName}_${methodName}_REQUEST`,
  [`${methodName}_SUCCESS`]: `${PREFIX_NAME}_${constName}_${methodName}_SUCCESS`,
  [`${methodName}_FAILURE`]: `${PREFIX_NAME}_${constName}_${methodName}_FAILURE`,
});

export const ID = (payload = {}) => `${payload.entityType}-${payload.entityId}`;
export const USER_ID = (payload = {}) => `${payload.userType}-${payload.id}`;
export const REQPROFILE_ID = (payload = {}) => `REQPROFILE-${payload.id}`;
export const CHAT_ID = (payload = {}) => `CHAT-${payload.chatGroupId}`;

export const REQUEST_LOGIN_CREDENTIALS = {
  ...PREFIX_CONST_REQUEST('CREATE', 'REQUEST_LOGIN_CREDENTIALS'),
  ...PREFIX_CONST_REQUEST('RESET', 'REQUEST_LOGIN_CREDENTIALS'),
};

export const AUTHENTICATION = {
  ...PREFIX_CONST_REQUEST('CREATE', 'AUTHENTICATION'),
  ...PREFIX_CONST_REQUEST('RESET', 'AUTHENTICATION'),
};

export const CURRENT_USER = {
  ...PREFIX_CONST_REQUEST('GET', 'CURRENT_USER'),
  ...PREFIX_CONST_REQUEST('SET_LANGUAGE', 'CURRENT_USER'),
  ...PREFIX_CONST_REQUEST('SET_PROFILE_PICTURE', 'CURRENT_USER')
};

export const METADATA = {
  ...PREFIX_CONST_REQUEST('GET', 'METADATA'),
  ...PREFIX_CONST_REQUEST('GET_HOBBIES', 'METADATA')
};

export const COMPANY_ONBOARDING = {
  ...PREFIX_CONST_REQUEST('CREATE_COMPANY_USER', 'COMPANY_ONBOARDING'),
  ...PREFIX_CONST_REQUEST('CREATE_COMPANY', 'COMPANY_ONBOARDING'),
};

export const COMPANY = {
  ...PREFIX_CONST_REQUEST('GET_DETAIL', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('GET_ALL', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('FOLLOW', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('GENUINE_INTEREST', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('GET_FEED', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('CREATE_FEED_POST', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('CREATE_USER', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('GET_FOLLOWERS', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('UPDATE_COMPANY', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('UPDATE_COMPANY_USER', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('UPDATE_COMPANY_COVER_IMAGE', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('DELETE_HITPOST', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('CONNECT_INSTAGRAM', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('DELETE_INSTAGRAM', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('GET_HITEVENTS', 'COMPANY'),
  ...PREFIX_CONST_REQUEST('GET_HITEVENTS_DEBOUNCED', 'COMPANY')
};

export const HITFACTOR_COLLECTIONS = {
  ...PREFIX_CONST_REQUEST('GET', 'HITFACTOR_COLLECTIONS'),
  ...PREFIX_CONST_REQUEST('CREATE', 'HITFACTOR_COLLECTIONS'),
  ...PREFIX_CONST_REQUEST('UPDATE', 'HITFACTOR_COLLECTIONS'),
  ...PREFIX_CONST_REQUEST('CREATE_IMAGE', 'HITFACTOR_COLLECTIONS'),
  ...PREFIX_CONST_REQUEST('UPDATE_IMAGE', 'HITFACTOR_COLLECTIONS'),
  ...PREFIX_CONST_REQUEST('DELETE_COLLECTION', 'HITFACTOR_COLLECTIONS'),
  ...PREFIX_CONST_REQUEST('DELETE_IMAGE', 'HITFACTOR_COLLECTIONS'),
  ...PREFIX_CONST_REQUEST('MOVE_IMAGE', 'HITFACTOR_COLLECTIONS'),
  ...PREFIX_CONST_REQUEST('MOVE_COLLECTION', 'HITFACTOR_COLLECTIONS')
  // ...PREFIX_CONST_REQUEST('CREATE_WITH_INSPIRATION', 'HITFACTOR_COLLECTIONS'),
};

export const COMMENTS = {
  ...PREFIX_CONST_REQUEST('GET', 'COMMENTS'),
  ...PREFIX_CONST_REQUEST('CREATE', 'COMMENTS'),
  ...PREFIX_CONST_REQUEST('DELETE', 'COMMENTS'),
};

export const LIKES = {
  ...PREFIX_CONST_REQUEST('GET', 'LIKES'),
  ...PREFIX_CONST_REQUEST('CREATE', 'LIKES'),
  ...PREFIX_CONST_REQUEST('DELETE', 'LIKES'),
};

export const STUDENT = {
  ...PREFIX_CONST_REQUEST('GET', 'STUDENT'),
};

export const HITSEARCH = {
  ...PREFIX_CONST_REQUEST('GET', 'HITSEARCH'),
  ...PREFIX_CONST_REQUEST('GET_NEXT', 'HITSEARCH'),
  ...PREFIX_CONST_REQUEST('RESET', 'HITSEARCH'),
}

export const APP_SETTINGS = {
  ...PREFIX_CONST_REQUEST('SET', 'APP_SETTINGS'),
  ...PREFIX_CONST_REQUEST('RESET', 'APP_SETTINGS'),
  ...PREFIX_CONST_REQUEST('SET_SELECTED_HITCLUB', 'APP_SETTINGS')

}

export const APP_TOUR = {
  ...PREFIX_CONST_REQUEST('SET_STATUS', 'APP_TOUR'),
  ...PREFIX_CONST_REQUEST('SAVE_STATUS', 'APP_TOUR'),
  ...PREFIX_CONST_REQUEST('RESET', 'APP_TOUR'),
}

export const HITMANAGER = {
  ...PREFIX_CONST_REQUEST('GET_STUDENTINFO', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('GET_REQPROFILE', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('GET_REQPROFILES', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('CREATE_REQPROFILE', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('GET_STUDENTS_IN_REQPROFILE', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('GET_STUDENTS_IN_REQPROFILES', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('GET_HITACTIONS', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('GET_STUDENT_INFO_LOG', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('GET_NONUPDATED_STUDENTS_IN_REQPROFILES', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('SEARCH_STUDENTS_IN_REQPROFILES', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('SEARCH_STUDENTS_IN_REQPROFILE', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('ADD_STUDENT_REQPROFILE', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('ADD_HITACTION', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('UPDATE_HITACTION', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('UPDATE_REQPROFILE', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('UPDATE_STUDENT_REQPROFILE', 'HITMANAGER'), // For indivudual reqProfile
  ...PREFIX_CONST_REQUEST('UPDATE_STUDENT_REQPROFILES', 'HITMANAGER'), // For master list
  ...PREFIX_CONST_REQUEST('UPDATE_NON_UPDATED_STUDENT_REQPROFILES', 'HITMANAGER'), // For nonUpdated student list
  ...PREFIX_CONST_REQUEST('DELETE_STUDENTS_REQPROFILE', 'HITMANAGER'), // For reqProfile
  ...PREFIX_CONST_REQUEST('DELETE_STUDENTS_REQPROFILES', 'HITMANAGER'), // For master list
  ...PREFIX_CONST_REQUEST('DELETE_REQPROFILE', 'HITMANAGER'),
  ...PREFIX_CONST_REQUEST('DELETE_HITACTION', 'HITMANAGER'),
};

export const CHAT = {
  ...PREFIX_CONST_REQUEST('GET_ALL_CHAT_GROUP', 'CHAT'),
  ...PREFIX_CONST_REQUEST('GET_CURRENT_CHAT_GROUPS', 'CHAT'),
  ...PREFIX_CONST_REQUEST('GET_CHAT_MESSAGES', 'CHAT'),
  ...PREFIX_CONST_REQUEST('CREATE_CHAT_GROUP', 'CHAT'),
  ...PREFIX_CONST_REQUEST('CREATE_MULTIPLE_CHAT_GROUP_BY_REQID', 'CHAT'),
  ...PREFIX_CONST_REQUEST('CREATE_MULTIPLE_CHAT_GROUP_BY_HITCLUBID', 'CHAT'),
  ...PREFIX_CONST_REQUEST('CREATE_MULTIPLE_CHAT_GROUP_BY_STUDENTID', 'CHAT'),
  ...PREFIX_CONST_REQUEST('ADD_CHAT_GROUP_PARTICIPANTS', 'CHAT'),
  ...PREFIX_CONST_REQUEST('DELETE_CHAT_GROUP_PARTICIPANTS', 'CHAT'),
  ...PREFIX_CONST_REQUEST('CREATE_CHAT_MESSAGE', 'CHAT'),
  ...PREFIX_CONST_REQUEST('CREATE_CHAT_MESSAGE_WITH_IMAGE', 'CHAT'),
  ...PREFIX_CONST_REQUEST('COUNT', 'CHAT'),
  ...PREFIX_CONST_REQUEST('RESET', 'CHAT'),
  ...PREFIX_CONST_REQUEST('POLL', 'CHAT'),
  ...PREFIX_CONST_REQUEST('CREATE_SINGLE_CHAT_MESSAGE', 'CHAT'),
  ...PREFIX_CONST_REQUEST('USER_TYPING', 'CHAT'),
  ...PREFIX_CONST_REQUEST('DISPATCH_USER_TYPING', 'CHAT'),
  ...PREFIX_CONST_REQUEST('USER_TYPING_DELETE', 'CHAT'),
  ...PREFIX_CONST_REQUEST('SEARCH_CHAT_GROUP', 'CHAT')
};

export const SEARCHGENERAL = {
  ...PREFIX_CONST_REQUEST('STUDENT_SEARCH', 'SEARCHGENERAL'),
  ...PREFIX_CONST_REQUEST('USER_SEARCH', 'SEARCHGENERAL'),
  ...PREFIX_CONST_REQUEST('HITCLUB_SEARCH', 'SEARCHGENERAL'),
  ...PREFIX_CONST_REQUEST('COMPANY_SEARCH', 'SEARCHGENERAL'),
  ...PREFIX_CONST_REQUEST('PRODUCT_BASE_SEARCH', 'SEARCHGENERAL'),
  ...PREFIX_CONST_REQUEST('PRODUCT_OFFER_SEARCH', 'SEARCHGENERAL'),
  ...PREFIX_CONST_REQUEST('HITMEMBER_TO_CHAT_WITH_SEARCH', 'SEARCHGENERAL')
}

export const NOTIFICATIONS = {
  ...PREFIX_CONST_REQUEST('ADD_DEVICE', 'NOTIFICATIONS'),
  ...PREFIX_CONST_REQUEST('GET_NOTIFICATIONS', 'NOTIFICATIONS'),
  ...PREFIX_CONST_REQUEST('SET_NOTIFICATION_CLICKED', 'NOTIFICATIONS'),
  ...PREFIX_CONST_REQUEST('POLL', 'NOTIFICATIONS'),
  ...PREFIX_CONST_REQUEST('SEND_PUSH_NOTIFICATION', 'NOTIFICATIONS'),
  ...PREFIX_CONST_REQUEST('SEND_PUSH_NOTIFICATION_HITCLUB', 'NOTIFICATION'),
  ...PREFIX_CONST_REQUEST('SEND_PUSH_NOTIFICATION_HITCLUB_EXPIRED', 'NOTIFICATION')
}

export const BUDDIES = {
  ...PREFIX_CONST_REQUEST('GET_APPROVED_BUDDIES', 'BUDDIES')
}

export const TRAITS = {
  ...PREFIX_CONST_REQUEST('GET_CHARACTERISTIC_GIVERS', 'TRAITS'),
}

export const HITCLUB = {
  ...PREFIX_CONST_REQUEST('GET_HITCLUBS_MENU', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITCLUB', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITCLUBS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITCLUB_MEMBERS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITCLUB_MEMBERS_DEBOUNCED', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITCLUB_HITEVENT', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITCLUB_HITEVENTS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITCLUB_HITEVENTS_DEBOUNCED', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITCLUB_MEMBERS_REQUESTS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_HITCLUB', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('EDIT_HITCLUB', 'HITEVENT'),
  ...PREFIX_CONST_REQUEST('CREATE_HITEVENT', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('EDIT_HITEVENT', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('APPROVE_MEMBER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('APPROVE_MEMBERS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_CLUB_OWNER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_CLUB_OWNER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('UPDATE_CLUB_OWNER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_CLUB_OWNER_OTHER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('REMOVE_CLUB_OWNER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('IMPORT_MEMBERS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('SEND_REMINDER_MEMBERS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('SEND_REMINDER_ALL', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('EDIT_HITMEMBER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('REMOVE_HITMEMBER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_TICKET', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('EDIT_TICKET', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_EDIT_TICKET_INFO', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_TICKET_QUESTIONS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_TICKET_QUESTIONS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('DELETE_TICKET_QUESTIONS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('EDIT_TICKET_QUESTIONS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('REMOVE_TICKET', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_MEMBERSHIP_OFFER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('EDIT_MEMBERSHIP_OFFER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_EDIT_MEMBERSHIP_OFFER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('DELETE_MEMBERSHIP_OFFER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('REMOVE_HITEVENT', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CONNECT_INSTAGRAM', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('MEMBER_LOG', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('UPLOAD_ADMISSION_FILE', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('UPLOAD_REGISTRATION_FILE', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('ADD_MEMBER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('UPLOAD_REGISTRATION_FILE', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_FEED', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITEVENT_FEED', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('DELETE_STUDENT_POST', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_STUDENT_POST', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('EDIT_STUDENT_POST', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('DELETE_INSTAGRAM', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('UPDATE_MEMBER_STATUS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('EDIT_HITEVENT_PARAMETERS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_TICKET_PARAMETERS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('EDIT_TICKET_PARAMETERS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('DELETE_INSTAGRAM_POST', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_PAYOUT_REPORT', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_SALES_REPORT', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_PRODUCT_BASE', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_PRODUCT_BASES', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_PRODUCT_BASES_DEBOUNCED', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_PRODUCT_BASE', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('UPDATE_PRODUCT_BASE', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('REMOVE_PRODUCT_BASE', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_PRODUCT_GROUPS', 'HITEVENT'),
  ...PREFIX_CONST_REQUEST('CREATE_HITEVENT_PRODUCT_GROUP', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('EDIT_HITEVENT_PRODUCT_GROUP', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('REMOVE_HITEVENT_PRODUCT_GROUP', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITEVENT_PRODUCT_GROUP_OFFERS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_HITEVENT_PRODUCT_OFFER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('EDIT_HITEVENT_PRODUCT_OFFER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('REMOVE_HITEVENT_PRODUCT_OFFER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITEVENT_TICKETS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITEVENT_PRODUCT_OFFER', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_EDIT_PRODUCT_GROUP_INFO', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_ELECTION_POST', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('UPDATE_ELECTION_POST', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('REMOVE_ELECTION_POST', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('MOVE_ELECTION_POST', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_ELECTION_POSTS', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_CANDIDACIES', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_CANDIDACY', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('UPDATE_CANDIDACY', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('REMOVE_CANDIDACY', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('MOVE_CANDIDACY', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('HITEVENT_ELECTION_RESULT', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('ELECTION_POST_RESULT', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('MOVE_MEMBERSHIP', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('CREATE_MEMBERS_REPORT', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITCLUB_ACTIVE_STUDENTS_DEBOUNCED', 'HITCLUB'),
  ...PREFIX_CONST_REQUEST('GET_HITCLUB_ACTIVE_SUBMEMBERSHIPS', 'HITCLUB')  
}

export const PAYMENTS = {
  ...PREFIX_CONST_REQUEST('CREATE_ACCOUNT', 'PAYMENTS'),
  ...PREFIX_CONST_REQUEST('CHECK_ACCOUNT_CREATION', "PAYMENTS"),
  ...PREFIX_CONST_REQUEST('GET_PAYMENT_REPORTS', 'PAYMENTS'),
  ...PREFIX_CONST_REQUEST('GET_PAYMENT_REPORTS_DEBOUNCED', 'PAYMENTS'),
  ...PREFIX_CONST_REQUEST('GET_PAYMENT_EVENTS', 'PAYMENTS'),
  ...PREFIX_CONST_REQUEST('GET_PAYMENT_EVENTS_DEBOUNCED', 'PAYMENTS'),
};


